<div class="tag-description">
    <ul>
        <h3>With exciting features </h3>
        <li class="tag-desc-item active">Up to <strong>20Gbps</strong> Data Transfer</li>
        <li class="tag-desc-item">Recharge <strong>80%</strong> in an <strong>hour</strong></li>
        <li class="tag-desc-item">Up to <strong>800W</strong> Power Transfer</li>
        <li class="tag-desc-item ">Up to <strong>8 USB-C </strong>Ports</li>
        <li class="tag-desc-item">Up to <strong>300Wh </strong>Capacity</li>
    </ul>
</div>